import {CheckCircleIcon} from "@heroicons/react/24/solid";
import React from "react";

export default function DocumentDeliveredCard() {


    const styles = {
        width: "100%",
        margin: "auto",
        position: "absolute",
        top: "30%",
        zIndex: "100"
    };

    return (
        <div style={styles} className="p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">

            <h5  style={{display: "inline"}} className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Dokument gemt.</h5>

            <p  className="mb-3 font-normal text-gray-700 dark:text-gray-400">Dokumentet blev gemt korrekt. Du kan nu lukke dette vindue eller gå til start siden.</p>
            <a  href="#" className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                Gå til start
                <svg className="w-3.5 h-3.5 ml-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
                </svg>
            </a>
        </div>
    );
}